import { GenIcon } from '../helpers/IconBase.es.js';

const ButtonOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M13.6 4H2.40005C1.52005 4 0.800049 4.72 0.800049 5.6V10.4C0.800049 11.28 1.52005 12 2.40005 12H13.6C14.48 12 15.2 11.28 15.2 10.4V5.6C15.2 4.72 14.48 4 13.6 4ZM14.4 9.6C14.4 10.08 14.08 10.4 13.6 10.4H2.40005C1.92005 10.4 1.60005 10.08 1.60005 9.6V5.6C1.60005 5.12 1.92005 4.8 2.40005 4.8H13.6C14.08 4.8 14.4 5.12 14.4 5.6V9.6Z",
          fill: "#A7ABC3"
        }
      }
    ]
  })(props);
};

export { ButtonOutlined };
